interface SkeletonTableProps {
  columns?: number;
  rows?: number;
}

export function SkeletonTable({ columns = 6, rows = 5 }: SkeletonTableProps) {
  return (
    <div className="tw-overflow-hidden tw-bg-white tw-rounded-lg tw-shadow-md">
      <div className="tw-animate-pulse">
        {/* Header skeleton */}
        <div className="tw-bg-gradient-to-br tw-from-[#8074af]/60 tw-to-[#575fa7]/60 tw-h-11" />

        {/* Rows skeleton */}
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            className={`tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3.5 ${
              rowIndex < rows - 1 ? 'tw-border-b tw-border-gray-100' : ''
            }`}
          >
            {Array.from({ length: columns }).map((_, colIndex) => {
              // Vary widths for visual realism
              const widths = ['tw-w-24', 'tw-w-32', 'tw-w-20', 'tw-w-28', 'tw-w-16', 'tw-w-36'];
              const w = widths[colIndex % widths.length];
              return (
                <div key={colIndex} className="tw-flex-1">
                  <div className={`tw-h-3.5 tw-bg-gray-200 tw-rounded ${w} tw-max-w-full`} />
                  {colIndex < 2 && (
                    <div className="tw-h-2.5 tw-bg-gray-100 tw-rounded tw-w-16 tw-mt-1.5" />
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
